import { render, staticRenderFns } from "./allFull.vue?vue&type=template&id=ea3dde78&scoped=true"
import script from "./allFull.vue?vue&type=script&setup=true&lang=js"
export * from "./allFull.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3dde78",
  null
  
)

export default component.exports